import React, { useRef, useState } from "react";
import * as yup from "yup";
import {
    Section,
    Breadcrumbs,
    ProgressComponent,
  } from "../../../shared";
import axios from "axios";
import { Form, Button, Col } from "react-bootstrap";

const schema = yup.object().shape(
    {
      fromDate: yup.string().required("Ship From Date is required."),
      toDate: yup.string().required("Ship To Date is required."),
    },
  );


export default function QuarterFacilityExportReport(props) {
    const [backToUrl, setBacktoUrl] = useState("/reports");
    const formRef = useRef();
    const [progressPercentage, setProgressPercentage] = useState(0);
    const [progressPercentage2, setProgressPercentage2] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [value, setValue] = useState(
        Math.round(Math.random() * (44 - 20)) + 20
      );
    const [stop, setStop] = useState(false);
    const [isSubmitting,setIsSubmitting] = useState(false);
    const [initialFormValues, setInitialFormValues] = useState({
        fromDate : "",
        toDate : "",
    });
    const [formValue, setformValue] = React.useState({
        fromDate : "",
        toDate : "",
      });

    const handleChange = (event) => {
        setformValue({
          ...formValue,
          [event.target.name]: event.target.value
        });
      }

    const handleSubmit = async (e) => {
        e.preventDefault();
        let value = 100;
        setIsLoading(true);
        setIsSubmitting(true);
        await axios({
            url: `/api/v1/hwts/Handler/quarterHandlerReort?fromDate=${formValue.fromDate}&toDate=${formValue.toDate}`,
            method: "GET",
            responseType: "blob", // important
            onDownloadProgress:(progressEvent) => {
                let percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  );
        
                  if (percentCompleted > 90) {
                    setProgressPercentage2(value >= 100 ? value - 1 : value++);
                    setStop(true);
                  }
            }
        })
        .then((res) => {
        setStop(false); // stopping progress count
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        let filename = "DataFile.txt";
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        setIsLoading(false);
        setIsSubmitting(false);
        })
        .catch((err) => {
        setIsLoading(false);
        setIsSubmitting(false);
        alert(err);
        });
    };

    const resetValue = () => {
        setformValue(
            {
                fromDate : "",
                toDate : "",
              });
    }

    return (
        <React.Fragment>
            <Section
                title={
                <span style={{ color: "white" }}>
                    Quarterly ID Number Export
                </span>
                }
                type={"standout"}
            />

            <div id="page-container" className="container" style={{ position: "relative" }}>
                <Breadcrumbs
                breadcrumbs={[
                    { name: "HWTS Reports", url: "/reports", active: false },
                    {
                    name: "Quarterly ID Number Export",
                    url: "",
                    active: true,
                    },
                ]}
                />
                <Form onSubmit={(handleSubmit)}>
                    <Form.Row>
                        <Form.Group className="form-group col-md-2">
                            <Form.Label>Issued From Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    placeholder=""
                                    name= "fromDate"
                                    value={formValue.fromDate}
                                    onChange={handleChange}
                                    // isInvalid={!!props.errors[props.name]}                        
                                />
                        </Form.Group>
                        <Form.Group className="form-group col-md-2">
                            <Form.Label>Issued To Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    placeholder=""
                                    name= "toDate"
                                    value={formValue.toDate}
                                    onChange={handleChange}
                                    // isInvalid={!!props.errors[props.name]}                        
                                />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} md="1">
                            <Button
                                //onClick={() => handleSubmit()}
                                type="submit"
                                className="btn-block-xs"
                                disabled={isSubmitting}
                                style={{ width: "100%" }}
                            >
                                Download
                            </Button>
                        </Form.Group>
                        <Form.Group as={Col} md="1">
                            <Button
                                onClick={() => resetValue()}
                                className="btn-block-xs"
                                disabled={isSubmitting}
                                style={{ width: "100%" }}
                            >
                                Reset
                            </Button>
                        </Form.Group>
                    </Form.Row>
                </Form>
            </div>
            <div className="m-b-md" style={{ position: "relative" }}>
                <ProgressComponent
                    percent={progressPercentage}
                    setProgressPercentage={setProgressPercentage}
                    percent2={progressPercentage2}
                    grid={true}
                    isLoading={isLoading}
                    value={value}
                    stop={stop}
                />
            </div>
        </React.Fragment>
    );

}


